import { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

interface IPortalProps {
  children?: React.ReactNode;
}

const Portal = ({ children }: IPortalProps): React.ReactPortal | null => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  // biome-ignore lint/style/noNonNullAssertion: #portal is always present in the DOM
  return mounted ? createPortal(children, document.querySelector('#portal')!) : null;
};

export default Portal;
